import {
  BellOutlined,
  CreditCardOutlined,
  DollarOutlined,
  FlagOutlined,
  HomeOutlined,
  NodeIndexOutlined,
  NotificationFilled,
  PercentageOutlined,
  PieChartOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
  SolutionOutlined,
  SettingOutlined,
  StarOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons/lib/icons";
import {
  CopyAll,
  MarkChatReadOutlined,
  Message,
  MessageOutlined,
} from "@mui/icons-material";
import KeyIcon from "@mui/icons-material/Key";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import { Layout as AntLayout, Button, Input, Menu, Popover, Tooltip, theme } from "antd";
import React, { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../Components/Logo/Logo";
import CheckPermission from "../../Util/CheckPermission";
import styles from "./Layout.module.css";
import api from "../../api/api";

const { Header, Sider, Content } = AntLayout;
const MENU_POSITION_KEY = "panel-admin-menu-position";
const MENU_COLLAPSED_KEY = "panel-admin-menu-collapsed";
const normalizeMenuTitle = (value) =>
  value
    .replace(/[يى]/g, "ی")
    .replace(/ك/g, "ک")
    .replace(/[\s\u200c\u200d]/g, "")
    .toLowerCase();
const getStoredMenuCollapsed = () => {
  try {
    const stored = localStorage.getItem(MENU_COLLAPSED_KEY);
    return stored === "true" ? true : stored === "false" ? false : null;
  } catch {
    return null;
  }
};
const createNavItem = (path, label, icon) => {
  return {
    key: path,
    icon,
    label: (
      <Link to={path} className={styles.navLink}>
        {label}
      </Link>
    ),
  };
};

const Layout = ({ permissions, role }) => {
  const [menuPosition, setMenuPosition] = useState(() => {
    try {
      return localStorage.getItem(MENU_POSITION_KEY) === "right" ? "right" : "top";
    } catch {
      return "top";
    }
  });
  const [collapsed, setCollapsed] = useState(() => getStoredMenuCollapsed() ?? false);
  const [menuSearch, setMenuSearch] = useState("");
  const [monitors, setMonitors] = useState([]);
  const [monitorsHasError, setMonitorsHasError] = useState([]);
  const hasNotifications = monitorsHasError.length > 0;

  const navItems = [
    createNavItem("/", "خانه", <HomeOutlined />, false),
    CheckPermission("setting_list", permissions)
      ? createNavItem("/settings", "تنظیمات سایت", <SettingOutlined />)
      : null,
    CheckPermission("roadmaps_list", permissions)
      ? createNavItem("/roadmaps", "نقشه راه ها", <UserOutlined />)
      : null,
    CheckPermission("flags_menu", permissions)
      ? createNavItem("/flags", "کارت‌ها", <FlagOutlined />)
      : null,
    CheckPermission("skills_menu", permissions)
      ? createNavItem("/skills", "مهارت‌ها", <StarOutlined />)
      : null,
    CheckPermission("ways_menu", permissions)
      ? createNavItem("/ways", "روش‌های یادگیری", <NodeIndexOutlined />)
      : null,
    CheckPermission("external_discount_list", permissions)
      ? createNavItem(
          "/external-discount",
          "کد‌‌های تخفیف",
          <PercentageOutlined />
        )
      : null,
    CheckPermission("forms_manager", permissions)
      ? createNavItem(
          "/question/new",
          "طراحی سوالات",
          <QuestionCircleOutlined />
        )
      : null,
    role != "result_editor" && CheckPermission("roadmaptype_list", permissions)
      ? createNavItem("/roadmapTypes", "تایپ‌ها", <SolutionOutlined />)
      : null,
    CheckPermission(
      ["users_status_list", "reports_answers_note_count"],
      permissions
    )
      ? createNavItem("/reports", "گزارشات", <PieChartOutlined />)
      : null,
    //  role != 'result_editor' && CheckPermission(['users_status_list','reports_answers_note_count'] , permissions) ? createNavItem('/permissions' , 'دسترسی‌ها' , <LockOutlined /> ) : null ,
    CheckPermission("skip_payment", permissions)
      ? createNavItem("/payment/skip", "رد کردن پرداخت", <DollarOutlined />)
      : null,
    CheckPermission("manage_products", permissions)
      ? createNavItem(
          "/product",
          "مدیریت محصولات",
          <ProductionQuantityLimitsIcon />
        )
      : null,
    CheckPermission("access_manager", permissions)
      ? createNavItem("/permission_manager", "مدیریت دسترسی‌ها", <KeyIcon />)
      : null,
    CheckPermission("manage_auto_note", permissions)
      ? createNavItem("/auto-note-manager", "نظر کارشناس", <TextIncreaseIcon />)
      : null,
    CheckPermission("roadmaps_copy", permissions)
      ? createNavItem("/copy-roadmap", "کپی نقشه راه", <CopyAll />)
      : null,
    CheckPermission("switch_username", permissions)
      ? createNavItem(
          "/switch-username",
          "جابجایی شماره موبایل",
          <UserSwitchOutlined />
        )
      : null,
    CheckPermission("send_plain_sms", permissions)
      ? createNavItem("/send-plain-sms", "ارسال پیامک", <MessageOutlined />)
      : null,
    CheckPermission("send_predefined_sms", permissions)
      ? createNavItem(
          "/send-predefined-sms",
          "ارسال پیامک با قالب",
          <MessageOutlined />
        )
      : null,
    CheckPermission("predefined_sms_list", permissions)
      ? createNavItem(
          "/predefined-sms",
          "لیست پیامک با قالب",
          <MessageOutlined />
        )
      : null,
    CheckPermission("sms_template_list", permissions)
      ? createNavItem(
          "/sms-templates",
          "قالب‌های پیامک",
          <MessageOutlined />
        )
      : null,
    CheckPermission("sms_campaign_list", permissions)
      ? createNavItem("/sms-campaigns", "کمپین پیامک", <MessageOutlined />)
      : null,
    CheckPermission("sms_line_list", permissions)
      ? createNavItem("/sms-lines", "خطوط پیامک", <MessageOutlined />)
      : null,
    CheckPermission("notification_receiver_list", permissions)
      ? createNavItem(
          "/notifications",
          "گیرندگان اعلان",
          <BellOutlined />
        )
      : null,
    CheckPermission("sent_sms_report", permissions)
      ? createNavItem(
          "/sent-sms-report",
          "گزارش پیامک ارسالی",
          <MarkChatReadOutlined />
        )
      : null,
    CheckPermission("snapppay_payments", permissions)
      ? createNavItem(
          "/snapppay-payments",
          "پرداخت های اسنپ پی",
          <DollarOutlined />
        )
      : null,
    CheckPermission("snapppay_cancel", permissions)
      ? createNavItem(
          "/snapppay-cancel",
          "لغو پرداخت اسنپ پی",
          <DollarOutlined />
        )
      : null,
    CheckPermission("order_discount_get_all", permissions)
      ? createNavItem("/order-discount", "کد تخفیف سفارش", <DollarOutlined />)
      : null,
    CheckPermission("card_to_card_list", permissions)
      ? createNavItem("/card-to-cards", "کارت به کارت", <CreditCardOutlined />)
      : null,
    CheckPermission("leads_list", permissions) 
      ? createNavItem("/leads", "همه لیدها", <UsergroupAddOutlined />) 
      : null,
    CheckPermission("leads_my_list", permissions)
      ? createNavItem("/myleads", "لیدها", <UsergroupAddOutlined />)
      : null,
    CheckPermission("leads_renewal_list", permissions)
      ? createNavItem("/renewal-leads", "لیدهای نقشه دوم", <UsergroupAddOutlined />)
      : null,
    CheckPermission("lead_export_list", permissions)
      ? createNavItem("/lead-exports", "خروجی‌های لید", <UsergroupAddOutlined />)
      : null,
  ];
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const location = useLocation();
  const navigate = useNavigate();
  let seletedNav = "/";
  navItems.forEach((el) => {
    if (!el) {
      return;
    }
    if (el.key === location.pathname) {
      seletedNav = el.key;
    }
  });

  useEffect(() => {
    if (CheckPermission("check_monitors", permissions)) {
      checkMonitors();
      setInterval(() => {
        checkMonitors();
      }, 15_000);
    }
  }, [permissions]);

  const checkMonitors = () => {
    if(window.location.hostname === "localhost") {
      return;
    }
    api
      .get("/monitor/checkall")
      .then((response) => {
        setMonitors(response.data);
        setMonitorsHasError(response.data.filter((monitor) => !monitor.ok));
      })
      .catch((exception) => {
        setMonitors(exception.response.data);
        setMonitorsHasError(
          exception.response.data.filter((monitor) => !monitor.ok)
        );
      });
  };

  const isTopMenu = menuPosition === "top";
  const searchQuery = !isTopMenu && !collapsed ? normalizeMenuTitle(menuSearch) : "";
  const visibleNavItems = navItems.filter(
    (item) => item && normalizeMenuTitle(item.label.props.children).includes(searchQuery)
  );
  const notifications = CheckPermission("check_monitors", permissions) ? (
    <Popover
      placement={isTopMenu ? "bottomRight" : "leftTop"}
      trigger={["hover", "focus", "click"]}
      content={
        <div className={styles.NotificationContent} dir="rtl">
          {hasNotifications ? (
            <ul className={styles.NotificationList}>
              {monitorsHasError.map((monitor) => (
                <li key={monitor.monitor}>{monitor.message}</li>
              ))}
            </ul>
          ) : (
            "مشکلی وجود ندارد."
          )}
        </div>
      }
    >
      <Button
        type="text"
        className={styles.NotificationTrigger}
        aria-label="اعلان‌ها"
        icon={
          <NotificationFilled
            style={{
              color: monitors.length > 0
                ? hasNotifications ? "red" : "green"
                : "gray",
            }}
          />
        }
      >
        {!isTopMenu && !collapsed ? (
          <span style={{ color: hasNotifications ? "red" : undefined }}>
            اعلان‌ها
          </span>
        ) : null}
      </Button>
    </Popover>
  ) : null;
  const handleMenuCollapse = (nextCollapsed, type) => {
    if (type === "responsive") {
      // Preserve the saved preference when Sider checks its breakpoint on mount.
      setCollapsed(getStoredMenuCollapsed() ?? nextCollapsed);
      return;
    }
    setCollapsed(nextCollapsed);
    try {
      localStorage.setItem(MENU_COLLAPSED_KEY, String(nextCollapsed));
    } catch {
      // Keep the toggle usable when browser storage is unavailable.
    }
  };
  const toggleMenuPosition = () => {
    const nextPosition = isTopMenu ? "right" : "top";
    setMenuPosition(nextPosition);
    try {
      localStorage.setItem(MENU_POSITION_KEY, nextPosition);
    } catch {
      // Keep the toggle usable when browser storage is unavailable.
    }
  };
  const toggleLabel = isTopMenu ? "انتقال منو به راست" : "انتقال منو به بالا";
  const positionToggle = (
    <Tooltip title={toggleLabel} placement="rightBottom" trigger={["hover", "focus"]}>
      <Button
        className={styles.MenuPositionToggle}
        type="text"
        icon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d={isTopMenu
                ? "M14 3H18A3 3 0 0 1 21 6V18A3 3 0 0 1 18 21H14V3Z"
                : "M3 10V6A3 3 0 0 1 6 3H18A3 3 0 0 1 21 6V10H3Z"}
              fill="currentColor"
            />
            <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.75" />
          </svg>
        }
        onClick={toggleMenuPosition}
        aria-label={toggleLabel}
      />
    </Tooltip>
  );
  const menu = visibleNavItems.length === 0 ? (
    <div className={styles.MenuEmpty} role="status">
      منویی پیدا نشد.
    </div>
  ) : (
    <Menu
      className={styles.Menu}
      mode={isTopMenu ? "horizontal" : "inline"}
      selectedKeys={[seletedNav]}
      items={visibleNavItems}
      onClick={({ key }) => {
        const item = navItems.find((el) => el?.key === key);
        if (!item || item.children) {
          return;
        }
        if (typeof key === "string" && key.startsWith("/")) {
          navigate(key);
        }
      }}
    />
  );

  return (
    <AntLayout
      hasSider={!isTopMenu}
      className={`${styles.Layout} ${isTopMenu ? styles.TopMenuLayout : ""}`}
    >
      {isTopMenu ? (
        <Header className={styles.Header}>
          {positionToggle}
          {notifications}
          {notifications && <span className={styles.NotificationDivider} aria-hidden="true" />}
          {menu}
          <div className={styles.Logo}>
            <Logo />
          </div>
        </Header>
      ) : (
        <Sider
          className={styles.Sidebar}
          theme="light"
          width={240}
          collapsedWidth={56}
          collapsible
          reverseArrow
          collapsed={collapsed}
          breakpoint="lg"
          onCollapse={handleMenuCollapse}
        >
          <div className={styles.SidebarControls}>{positionToggle}</div>
          <div className={styles.Logo}>
            <Logo
              width={collapsed ? 20 : 90}
              src={collapsed ? "/img/logo-s.png" : undefined}
            />
          </div>
          {notifications}
          {notifications && <span className={styles.NotificationDivider} aria-hidden="true" />}
          {!collapsed && (
            <div className={styles.MenuSearch}>
              <Input
                value={menuSearch}
                onChange={(event) => setMenuSearch(event.target.value)}
                placeholder="جستجوی منوها"
                aria-label="جستجوی عنوان منو"
                prefix={<SearchOutlined />}
                allowClear
              />
            </div>
          )}
          {menu}
        </Sider>
      )}
      <Content className={styles.Content}>
        <div
          className={styles.MainContent}
          style={{ background: colorBgContainer }}
        >
          <Outlet context={{ headerOffset: isTopMenu ? 64 : 0 }} />
        </div>
      </Content>
    </AntLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.userData ? state.userData.permissions : [],
    role: state.userData ? state.userData.role : null,
  };
};
export default connect(mapStateToProps)(memo(Layout));
